import { useContent } from '../App.jsx';
import PageHero from '../components/PageHero.jsx';
import { ArrowIcon, CalendarIcon } from '../components/Icons.jsx';

export default function SchedulePage() {
  const { content } = useContent();
  const downloads = content.schedule.downloads.filter((item) => item.published);
  return (
    <>
      <PageHero eyebrow={content.event.displayDate} title="Three days. A full year of momentum." body={content.schedule.intro} />
      <section className="section page-width schedule-page">
        <div className="schedule-timeline">
          {content.schedule.days.map((day, index) => (
            <article key={day.day}>
              <div className="timeline-marker"><span>0{index + 1}</span></div>
              <div className="schedule-day-heading"><p>{day.date}</p><h2>{day.day}</h2></div>
              <div className="schedule-items">{day.items.map((item) => <div key={item}><CalendarIcon /><span>{item}</span></div>)}</div>
            </article>
          ))}
        </div>
        <aside className="schedule-note">
          <p className="eyebrow">Class guides</p>
          {downloads.length > 0 ? (
            <>{downloads.map((download) => <a key={download.id} href={download.url} target="_blank" rel="noreferrer">{download.label}<ArrowIcon /></a>)}</>
          ) : (
            <><h3>Coming soon</h3><p>The detailed 2026 class guides are being finalized. Check back closer to the workshop for room assignments and individual sessions.</p></>
          )}
        </aside>
      </section>
    </>
  );
}
